module.exports = __webpack_public_path__ + "img/overall-trend-rvs.98e12309.png";